import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL, BASE_URL } from '../Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import axios from "axios";
import Select from 'react-select';
import CommonDatePicker from '../datepicker/CommonDatePicker';
import 'rsuite/dist/rsuite.min.css';
import Swal from 'sweetalert2';
import { useNavigate } from "react-router-dom";
import config from "../common/Config";
import { setTableWidths, getTableWidths } from "../../data/postAPi";
import "../../components/css/custom-filter.css";
const PickingCreate = (props) => {
  const [options, setOptions] = useState([]);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [picker, setSelectedPicker] = useState('');
  const [newOrders, setNewOrders] = useState([]);
  const [selectedOrderIds, setSelectedOrderIds] = useState([]);
  const [checkedItems, setCheckedItems] = useState({});
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerInputValue, setCustomerInputValue] = useState('');
  const [isSingleOrderPicking, setIsSingleOrderPicking] = useState(false);
  const navigateToOrderHistory = useNavigate();
  const accessToken = localStorage.getItem('accessToken');

  // Resizable columns state
  const [colWidths, setColWidths] = useState([60, 120, 120, 200, 150, 150, 150, 150]);
  const userId = localStorage.getItem("userId");
  const tableName = "pickingCreateTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const tableRef = useRef(null);
  const LOCAL_STORAGE_KEY = "pickingCreateTableColWidths";

  const pickerRef = useRef(null);

  // Resizable column functions
  const startResizing = (index, e) => {

    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];

    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(30, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  // Load saved column widths on mount
  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([60, 120, 120, 200, 150, 150, 150, 150]);
        }
      } catch (e) {
        setColWidths([60, 120, 120, 200, 150, 150, 150, 150]);
      }
    }
    fetchWidths();
  }, []);

  async function fetchData() {
    const accessToken = localStorage.getItem('accessToken');

    const formData = new FormData();
    formData.append('searchByFromdate', fromDate);
    formData.append('searchByTodate', toDate);
    formData.append('draw', draw);
    formData.append('start', start);
    formData.append('length', length);
    formData.append('pickerId', picker);
    formData.append('authorization', `Bearer ${accessToken}`);

    const apiUrl = `${API_URL}/create/picking`;

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to create picking');
      }

      const data = await response.json();

      // Set new orders from the response data
      setNewOrders(Array.isArray(data.data) ? data.data : []);
      if (data.isSingleOrderPicking === 'Y') {
        setIsSingleOrderPicking(true);
      }

    } catch (error) {
      console.error('Error creating picking:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchPickerOptions() {
      try {
        if (accessToken === null) {
          window.location.href = `${config.BASE_URL}/login`;
          return;
        }

        const response = await axios.get(`${API_URL}/getPicker`, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        });

        if (!response.data || !response.data.picker || !Array.isArray(response.data.picker)) {
          throw new Error('Invalid response format or empty picker array');
        }

        if (Array.isArray(response.data.picker)) {
          const formattedOptions = response.data.picker.map(item => ({
            label: `${item.first_name} ${item.last_name}`,
            value: item.id,
          }));
          setCustomerOptions(formattedOptions);
        }

      } catch (error) {
        console.error('Error fetching picker options', error);
      }
    }

    fetchPickerOptions();
  }, []);

  const handleChange = (selectedOption) => {
    setCustomerInputValue(selectedOption);
  };

  const handlePickerChange = (inputValue) => {
    setSelectedPicker(inputValue);
  };

  useEffect(() => {
    // Destroy existing DataTable if it exists
    if ($.fn.DataTable.isDataTable('#neworderTable')) {
      $('#neworderTable').DataTable().destroy();
    }

    const table = $('#neworderTable').DataTable({
      paging: true,
      lengthMenu: [10, 20, 50, 100, 500],
      pageLength: 50,
      searching: true,
      ordering: false,
      info: true,
      responsive: false,
      autoWidth: false,
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      data: newOrders,
      columns: [
        {
          data: null,
          width: colWidths[0] + 'px',
          className: 'text-center',
          render: function (data, type, row) {
            return `<div class="radio-tbl"><label class="checkbox"><input type="checkbox" class="checkbox multi-select input-xs" name="val[]" value="${row.id}"/><span class="default"></span></label></div>`;
          }
        },
        {
          data: 'date',
          width: colWidths[1] + 'px',
          className: 'text-center'
        },
        {
          data: 'reference_no',
          width: colWidths[2] + 'px',
          className: 'text-center',
          render: function (data, type, row) {
            return '<a class="underlined-link" href="' + BASE_URL + '/picking/picking_list/view/' + row.id + '">' + row.reference_no + '</a>';
          }
        },
        {
          data: 'customer',
          width: colWidths[3] + 'px',
          render: function (data) {
            return `<p>${data}</p>`;
          },
        },
        {
          data: 'postal_code',
          width: colWidths[4] + 'px',
          className: 'text-center'
        },
        {
          data: 'route_number',
          width: colWidths[5] + 'px',
          className: 'text-center'
        },
          {
          data: 'grand_total',
          width: colWidths[6] + 'px',
          className: 'text-end',
        },
         
        {
          data: 'first_name',
          width: colWidths[7] + 'px',
          className: 'text-center'
        },
        {
          data: 'deliverydate',
          width: colWidths[8] + 'px',
          className: 'text-center'
        },
      ],
    });

    // Add event listeners for resizers AFTER DataTable has rendered
    const addResizerListeners = () => {
      const resizers = document.querySelectorAll('#neworderTable .th-resizer');

      resizers.forEach((resizer, index) => {
        const handleMouseDown = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();

          console.log('Resizer clicked for column:', index);
          startResizing(index, e);
        };

        resizer.addEventListener('mousedown', handleMouseDown);

        // Store the handler for cleanup
        resizer._resizerHandler = handleMouseDown;
      });
    };

    // Use setTimeout to ensure DataTable has completely finished rendering
    const timeoutId = setTimeout(() => {
      addResizerListeners();
      $('#neworderTable thead th').each(function(idx) {
        $(this).css('width', colWidths[idx] + 'px');
      });
    }, 100);

    // Cleanup function
    return () => {
      clearTimeout(timeoutId);

      // Remove event listeners
      const resizers = document.querySelectorAll('#neworderTable .th-resizer');
      resizers.forEach((resizer) => {
        if (resizer._resizerHandler) {
          resizer.removeEventListener('mousedown', resizer._resizerHandler);
        }
      });

      // Destroy DataTable
      if ($.fn.DataTable.isDataTable('#neworderTable')) {
        table.destroy();
      }
    };
  }, [newOrders]);

  // Update checkbox states after table renders
  useEffect(() => {
    if ($.fn.DataTable.isDataTable('#neworderTable')) {
      $('#neworderTable tbody tr').each(function() {
        const checkbox = $(this).find('.multi-select');
        const orderId = checkbox.val();
        if (checkedItems[orderId]) {
          checkbox.prop('checked', true);
        } else {
          checkbox.prop('checked', false);
        }
      });
    }
  }, [checkedItems]);

  // Handle checkbox changes
  useEffect(() => {
    const handleCheckboxChange = (event) => {
      const checkbox = event.target;
      const orderId = checkbox.value;
      
      if (isSingleOrderPicking) {
        // For single order picking, uncheck all others
        const newCheckedItems = {};
        if (checkbox.checked) {
          newCheckedItems[orderId] = true;
        }
        setCheckedItems(newCheckedItems);
      } else {
        // For multiple order picking, toggle the specific checkbox
        const newCheckedItems = { ...checkedItems };
        if (checkbox.checked) {
          newCheckedItems[orderId] = true;
        } else {
          delete newCheckedItems[orderId];
        }
        setCheckedItems(newCheckedItems);
      }
    };

    // Add event listener for checkbox changes
    $(document).on('change', '#neworderTable .multi-select', handleCheckboxChange);

    // Cleanup
    return () => {
      $(document).off('change', '#neworderTable .multi-select', handleCheckboxChange);
    };
  }, [checkedItems, isSingleOrderPicking]);

  // Update selectedOrderIds when checkedItems changes
  useEffect(() => {
    const selectedIds = Object.keys(checkedItems);
    setSelectedOrderIds(selectedIds);
  }, [checkedItems]);

  // Handle button click to submit selected orders and picker to another API
  const handleSelectionSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission
    
    if (!customerInputValue.value || customerInputValue.value === "undefined") {
      Swal.fire({
        title: 'Failed!',
        text: 'Please select Picker first.',
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
      });
      pickerRef.current.focus();
      return;
    }

    if (selectedOrderIds.length === 0) {
      Swal.fire({
        title: 'Failed!',
        text: 'Please select at least one order.',
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
      });
      return;
    }

    const accessToken = localStorage.getItem('accessToken');

    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    const formData = new FormData();
    formData.append('picker', customerInputValue.value);
    selectedOrderIds.forEach(orderId => {
      formData.append('val[]', orderId);
    });

    try {
      const response = await fetch(`${API_URL}/create_picking`, {
        method: 'POST',
        headers: {
          'authorization': `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to submit selection');
      }

      const data = await response.json();

      if (data.status === 'true') {
        // Reset selected picker and checkboxes after successful picking creation
        setCustomerInputValue('');
        setSelectedPicker('');
        setCheckedItems({});
        setSelectedOrderIds([]);
        fetchData();
        const picklistUrl = data.picklist_number;
        const picklistNo = picklistUrl.substring(picklistUrl.lastIndexOf('/') + 1);
        Swal.fire({
          title: "Success!",
          text: "Create Picking successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = config.BASE_URL + `/sales/view_picking_list/${picklistNo}`;
        });

      } else {
        Swal.fire({
          title: 'Failed!',
          text: 'Please select order first.',
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
        });
      }

    } catch (error) {
      console.error('Error submitting selection:', error);
    }
  };
  const resizerStyles = `
    .th-resizer:hover {
      background-color: rgba(0, 0, 0, 0.3) !important;
    }
    
    .resizable-header {
      position: relative;
      user-select: none;
    }
  `;

  // Add styles to document
  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = resizerStyles;
    document.head.appendChild(styleSheet);

    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);
  
  return (
    <div>
      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i> </a>
              <span className="last-crumb">Create Picking</span>
            </div>
          </div>
        </div>
      </nav>

      <div className="main-container position-relative">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <div>
                <form id="picking_create" onSubmit={handleSelectionSubmit}>
                  <div className="dashform">
                    <div className="row picking-create-filter-row">
                      <div className='w-50 col-md-8'>
                        <Select
                          ref={pickerRef}
                          isClearable
                          onInputChange={handlePickerChange}
                          onChange={handleChange}
                          options={customerOptions}
                          placeholder="Select Picker"
                          value={customerInputValue}
                          // styles={{
                          //   menuPortal: base => ({ ...base, zIndex: 10 })
                          // }}
                          // menuPortalTarget={document.body}

                          menuPortalTarget={document.body}
                        styles={{
                          // Fixes the overlapping problem of the component
                          menu: provided => ({ ...provided, zIndex: 9999 }),
                          menuPortal: provided => ({ ...provided, zIndex: 9999 })
                        }}

                        />
                      </div>
                      <button type="submit" className="multisubmit col-md-2">
                        Submit
                      </button>
                    </div>
                  </div>

                  <div className='dashboard create-picking-table'>
                    <div className="verical-scrl-wrapper responsive-height-table common-table autoheight-table create-picking" id="style-3">

                      <table className="table table-bordered dataTable resizable resizable-columns" id="neworderTable" ref={tableRef}>
                        <thead>
                          <tr>
                            {["#", "Order Date", "Order Id", "Customers (Ac/No)", "Post Code", "Route No","Order Amt", "Order By", "Delivery Date"].map((header, idx) => (
                              <th
                                key={header}
                                className="resizable-header"
                                style={{
                                  width: colWidths[idx],
                                  minWidth: 50,
                                  position: "relative",
                                  padding: "8px"
                                }}
                              >
                                {header}
                                {idx < colWidths.length - 1 && (
                                  <div
                                    className="th-resizer"
                                    data-column-index={idx}
                                    title="Drag to resize column"
                                    style={{
                                      position: 'absolute',
                                      right: '-2px',
                                      top: 0,
                                      width: '5px',
                                      height: '100%',
                                      cursor: 'col-resize',
                                      // backgroundColor: 'rgba(0, 0, 0, 0.1)',
                                      zIndex: 999,
                                      userSelect: 'none'
                                    }}
                                  />
                                )}
                              </th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {/* DataTable will populate this */}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PickingCreate;